import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';

const API_BASE =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8081/api/v1'
    : '/api/v1';

export function LoginPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (localStorage.getItem('qrhost_token')) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || 'Credenciales incorrectas');
      }
      localStorage.setItem('qrhost_token', data.access_token);
      localStorage.setItem('qrhost_refresh_token', data.refresh_token);
      localStorage.setItem('qrhost_staff', JSON.stringify(data.staff));
      navigate('/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4" style={{ background: 'var(--qr-bg)', color: 'var(--qr-text)' }}>
      <div
        className="w-full max-w-sm p-6 rounded-2xl space-y-5 animate-fade-in"
        style={{ background: 'var(--qr-surface)', border: '1px solid var(--qr-border)' }}
      >
        <div className="text-center space-y-1">
          <h1 className="text-2xl font-extrabold">Iniciar sesión</h1>
          <p className="text-sm" style={{ color: 'var(--qr-text-secondary)' }}>
            Accede al panel de tu negocio
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <input
            type="email"
            required
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            className="w-full px-4 py-3 rounded-xl outline-none"
            style={{ background: 'var(--qr-bg)', border: '1px solid var(--qr-border)', color: 'var(--qr-text)' }}
          />
          <input
            type="password"
            required
            minLength={8}
            placeholder="Contraseña"
            value={form.password}
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
            className="w-full px-4 py-3 rounded-xl outline-none"
            style={{ background: 'var(--qr-bg)', border: '1px solid var(--qr-border)', color: 'var(--qr-text)' }}
          />
          {error && <p className="text-sm" style={{ color: 'var(--qr-danger)' }}>{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="flex items-center justify-center gap-2 w-full py-3 rounded-xl font-semibold transition-transform duration-200 active:scale-[0.98] disabled:opacity-60"
            style={{ background: 'var(--qr-primary)', color: '#fff' }}
          >
            <LogIn size={18} />
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <p className="text-sm text-center" style={{ color: 'var(--qr-text-secondary)' }}>
          ¿No tienes cuenta?{' '}
          <a href="/" className="underline hover:no-underline" style={{ color: 'var(--qr-primary)' }}>
            Crear negocio
          </a>
        </p>
      </div>
    </div>
  );
}
